/**
 * Onboarding API endpoints.
 */

import type { ApiClientOptions } from "./client";
import { createApiClient } from "./client";

export interface OnboardingProfile {
  id: string;
  age_confirmed: boolean | null;
  marketing_accepted: boolean | null;
  name: string | null;
  referral_source: string | null;
  role: string | null;
  content_goals: string[] | null;
  brand_name: string | null;
  voice_styles: string[] | null;
  custom_style_words: string | null;
  selected_plan: string | null;
  completed_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface OnboardingProfileUpdate {
  name?: string | null;
  referral_source?: string | null;
  role?: string | null;
  content_goals?: string[] | null;
  brand_name?: string | null;
  voice_styles?: string[] | null;
  custom_style_words?: string | null;
  selected_plan?: string | null;
}

export interface OnboardingCompleteResult {
  project_id: string;
}

export function createOnboardingApi(options: ApiClientOptions) {
  const api = createApiClient(options);

  return {
    /** Get the current user's onboarding profile (creates if missing). */
    getProfile: () =>
      api.get<OnboardingProfile>("/api/onboarding/profile"),

    /** Partial update — send only the fields from the current screen. */
    updateProfile: (data: OnboardingProfileUpdate) =>
      api.patch<OnboardingProfile>("/api/onboarding/profile", data),

    /** Finalize onboarding: picks template, creates first project. */
    complete: () =>
      api.post<OnboardingCompleteResult>("/api/onboarding/complete"),

    /** Mark the dashboard tour as completed in Clerk metadata. */
    completeTour: (skipped = false) =>
      api.post<void>("/api/onboarding/tour-complete", { skipped }),
  };
}
